// [lat, lng] approximate centroids for countries used in our datasets
export const centroids: Record<string, [number, number]> = {
  // North America
  US: [37.09, -95.71],
  CA: [56.13, -106.35],
  MX: [23.63, -102.55],
  // Caribbean
  CU: [21.52, -77.78],
  JM: [18.11, -77.3],
  HT: [18.97, -72.29],
  DO: [18.74, -70.16],
  TT: [10.69, -61.22],
  BB: [13.19, -59.54],
  GY: [4.86, -58.93],
  BZ: [17.19, -88.5],
  BS: [25.03, -77.4],
  AG: [17.06, -61.8],
  DM: [15.41, -61.37],
  GD: [12.11, -61.68],
  KN: [17.36, -62.78],
  LC: [13.91, -60.98],
  VC: [12.98, -61.29],
  PR: [18.22, -66.59],
  // Central America
  GT: [15.78, -90.23],
  SV: [13.79, -88.9],
  HN: [15.2, -86.24],
  NI: [12.87, -85.21],
  CR: [9.75, -83.75],
  PA: [8.54, -80.78],
  // South America
  CO: [4.57, -74.3],
  VE: [6.42, -66.59],
  BR: [-14.24, -51.93],
  EC: [-1.83, -78.18],
  PE: [-9.19, -75.02],
  BO: [-16.29, -63.59],
  PY: [-23.44, -58.44],
  AR: [-38.42, -63.62],
  CL: [-35.68, -71.54],
  UY: [-32.52, -55.77],
  // Europe
  GB: [55.38, -3.44],
  IE: [53.41, -8.24],
  FR: [46.23, 2.21],
  ES: [40.46, -3.75],
  PT: [39.4, -8.22],
  DE: [51.17, 10.45],
  AT: [47.52, 14.55],
  CH: [46.82, 8.23],
  LI: [47.14, 9.55],
  IT: [41.87, 12.57],
  BE: [50.5, 4.47],
  NL: [52.13, 5.29],
  LU: [49.82, 6.13],
  MC: [43.73, 7.4],
  SE: [60.13, 18.64],
  NO: [60.47, 8.47],
  FI: [61.92, 25.75],
  DK: [56.26, 9.5],
  PL: [51.92, 19.15],
  CZ: [49.82, 15.47],
  SK: [48.67, 19.7],
  HU: [47.16, 19.5],
  RO: [45.94, 24.97],
  BG: [42.73, 25.49],
  RS: [44.02, 21.0],
  MK: [41.61, 21.75],
  HR: [45.1, 15.2],
  BA: [43.92, 17.68],
  SI: [46.15, 14.99],
  AL: [41.15, 20.17],
  GR: [39.07, 21.82],
  CY: [35.13, 33.43],
  MT: [35.94, 14.38],
  LV: [56.88, 24.6],
  LT: [55.17, 23.88],
  EE: [58.6, 25.0],
  UA: [48.38, 31.17],
  BY: [53.71, 27.95],
  MD: [47.41, 28.37],
  // Former Soviet / Central Asia
  RU: [61.52, 105.32],
  KZ: [48.02, 66.92],
  UZ: [41.38, 64.59],
  TM: [38.97, 59.56],
  KG: [41.21, 74.77],
  TJ: [38.86, 71.28],
  AZ: [40.14, 47.58],
  AM: [40.07, 45.04],
  GE: [42.32, 43.36],
  // Middle East
  TR: [38.96, 35.24],
  SY: [34.8, 38.99],
  LB: [33.85, 35.86],
  IL: [31.05, 34.85],
  PS: [31.95, 35.23],
  JO: [30.59, 36.24],
  IQ: [33.22, 43.68],
  IR: [32.43, 53.69],
  SA: [23.89, 45.08],
  AE: [23.42, 53.85],
  KW: [29.34, 47.71],
  QA: [25.35, 51.18],
  BH: [26.0, 50.55],
  OM: [21.51, 55.92],
  YE: [15.55, 48.52],
  // South Asia
  IN: [20.59, 78.96],
  PK: [30.38, 69.35],
  BD: [23.68, 90.36],
  NP: [28.39, 84.12],
  BT: [27.51, 90.43],
  LK: [7.87, 80.77],
  AF: [33.94, 67.71],
  // East Asia
  CN: [35.86, 104.2],
  TW: [23.7, 120.96],
  JP: [36.2, 138.25],
  KR: [35.91, 127.77],
  MN: [46.86, 103.85],
  // Southeast Asia
  MM: [21.92, 95.96],
  TH: [15.87, 100.99],
  VN: [14.06, 108.28],
  LA: [19.86, 102.5],
  KH: [12.57, 104.99],
  MY: [4.21, 108.96],
  SG: [1.35, 103.82],
  ID: [-0.79, 113.92],
  PH: [12.88, 121.77],
  BN: [4.54, 114.73],
  TL: [-8.87, 125.73],
  // Oceania
  AU: [-25.27, 133.78],
  NZ: [-40.9, 174.89],
  FJ: [-17.71, 178.07],
  PG: [-6.31, 143.96],
  WS: [-13.76, -172.1],
  TO: [-21.18, -175.2],
  VU: [-15.38, 166.96],
  SB: [-9.65, 160.16],
  PF: [-17.68, -149.41],
  NC: [-20.9, 165.62],
  // Africa
  MA: [31.79, -7.09],
  DZ: [28.03, 1.66],
  TN: [33.89, 9.54],
  LY: [26.34, 17.23],
  EG: [26.82, 30.8],
  MR: [21.01, -10.94],
  ML: [17.57, -4.0],
  NE: [17.61, 8.08],
  TD: [15.45, 18.73],
  SD: [12.86, 30.22],
  SS: [6.88, 31.31],
  ER: [15.18, 39.78],
  DJ: [11.83, 42.59],
  ET: [9.15, 40.49],
  SO: [5.15, 46.2],
  SN: [14.5, -14.45],
  GM: [13.44, -15.31],
  GW: [11.8, -15.18],
  GN: [11.0, -10.9],
  SL: [8.46, -11.78],
  LR: [6.43, -9.43],
  CI: [7.54, -5.55],
  BF: [12.37, -1.56],
  GH: [7.95, -1.02],
  TG: [8.62, 0.82],
  BJ: [9.31, 2.32],
  NG: [9.08, 8.68],
  CM: [3.85, 11.5],
  CF: [6.61, 20.94],
  GQ: [1.65, 10.27],
  GA: [-0.8, 11.61],
  CG: [-0.23, 15.83],
  CD: [-4.04, 21.76],
  AO: [-11.2, 17.87],
  ZM: [-13.13, 27.85],
  MW: [-13.25, 34.3],
  MZ: [-18.67, 35.53],
  ZW: [-19.02, 29.15],
  BW: [-22.33, 24.68],
  ZA: [-28.48, 24.68],
  NA: [-22.96, 18.49],
  LS: [-29.61, 28.23],
  SZ: [-26.52, 31.47],
  KE: [-0.02, 37.91],
  UG: [1.37, 32.29],
  TZ: [-6.37, 34.89],
  RW: [-1.94, 29.87],
  BI: [-3.37, 29.92],
  MG: [-18.77, 46.87],
  KM: [-11.65, 43.33],
  MU: [-20.35, 57.55],
  SC: [-4.68, 55.49],
  CV: [16.0, -24.01],
  ST: [0.19, 6.61],
};
